import { ExaminerFunction } from '../../pages/Assessment/Assessment.types';

export interface IComment {
  commentId: string;
  examinerId: string;
  examinerFirstName: string;
  examinerLastName: string;
  examinerFunction: ExaminerFunction | null;
  commentTypeId: CommentTypeId;
  criterionName?: string;
  criterionPoints?: number | null;
  history: IHistoryCommment[] | null;
  content: string;
  x1: number | null;
  y1: number | null;
  x2?: number | null;
  y2?: number | null;
  pageNumber: number | null;
  partialScoreId?: string | null;
  createDate?: string;
  isVerifier?: boolean;
}

export interface IHistoryCommment {
  commentId: string;
  content: string;
  examinerId?: string;
  examinerFirstName?: string;
  examinerLastName?: string;
  examinerFunction?: ExaminerFunction | null;
  criterionPoints: number;
  isVerifier?: boolean;
}

export interface IComments {
  comments: IComment[];
}

export enum CommentTypeId {
  OFFPAGE,
  ONIMAGE,
  ONCRITERIA,
}
